import { FC } from "react";
import { PanelContentContainer } from "~/OnboardingApp/components";
import { usePartner } from "~/OnboardingApp/hooks";
import { PartnerCallout } from "./PartnerCallout";
import { PartnerTitle } from "./PartnerTitle";
import { Steps } from "./Steps";
import { Title } from "./Title";

export const LeftSection: FC = () => {
  const { isPartner } = usePartner();

  return (
    <PanelContentContainer
      bg="th.yellow1"
      gap={{ base: 6, md: 8 }}
      pb="2rem"
      px="1rem"
    >
      {isPartner ? (
        <>
          <PartnerTitle />
          <PartnerCallout />
        </>
      ) : (
        <>
          <Title />
          <Steps />
        </>
      )}
    </PanelContentContainer>
  );
};
